import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/@mui/system/esm/createTheme/index.js';

var require$$7 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$7 as default };
//# sourceMappingURL=index5.js.map
